import { usePalette } from "@/shared/theme";
import { IdcardOutlined } from "@ant-design/icons";
import { CSSProperties } from "react";
import { PositionNameFragment } from "gql/graphql";
import { hasName } from "@/shared/data-display/localized-value";
import { Hidable, Nothing } from "@/shared/value";
import { Position } from "../../position";

export function PersonPosition({
  data,
}: {
  data?: Hidable<PositionNameFragment>;
}) {
  const palette = usePalette();

  // Строка исчезает вместе с должностью: иконка без значения читается как пустая
  // должность, а не как её отсутствие. Скрытая должность строку сохраняет — плашка
  // «скрыто» и есть то, что здесь нужно показать.
  if (!hasName(data)) {
    return null;
  }

  return (
    <div
      className="space-x-2 text-[--color]"
      style={{ "--color": palette.neutral[5] } as CSSProperties}
    >
      <IdcardOutlined style={{ color: palette.neutral[5] }} />
      <Position.Name data={data} whenEmpty={Nothing} />
    </div>
  );
}
